import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { employeeAPI } from '../services/api';

const AddEmployeeDialog = ({ isOpen, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    department: '',
    deliveryUnit: 'DU1'
  });
  const [message, setMessage] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      await employeeAPI.create(formData);
      setMessage({ type: 'success', text: 'Employee created successfully!' });
      setFormData({
        name: '',
        email: '',
        department: '',
        deliveryUnit: 'DU1'
      });
      setTimeout(() => {
        onSave();
        onClose();
      }, 1000);
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.response?.data?.error || 'Failed to create employee'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({
      name: '',
      email: '',
      deliveryUnit: 'DU1',
      department: ''
    });
    setMessage({ type: '', text: '' });
    onClose();
  };

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div 
      className="add-employee-dialog-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 10001,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflowY: 'auto',
        padding: '20px'
      }}
      onClick={handleClose}
    >
      <div 
        className="add-employee-dialog-content"
        style={{
          backgroundColor: 'white',
          padding: '25px',
          borderRadius: '12px',
          minWidth: '500px',
          maxWidth: '600px',
          width: '100%',
          boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
          maxHeight: '90vh',
          overflowY: 'auto'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: '20px',
          borderBottom: '1px solid #e5e7eb',
          paddingBottom: '15px'
        }}>
          <h2 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 600, color: '#1f2937' }}>
            Add New Employee
          </h2>
          <button 
            onClick={handleClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#6b7280',
              padding: '0',
              width: '30px',
              height: '30px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f3f4f6';
              e.target.style.color = '#1f2937';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#6b7280';
            }}
          >
            ×
          </button>
        </div>

        {message.text && (
          <div className={`alert alert-${message.type}`} style={{ marginBottom: '20px' }}>
            {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="add-deliveryUnit">Delivery Unit *</label>
            <select
              id="add-deliveryUnit"
              name="deliveryUnit"
              value={formData.deliveryUnit}
              onChange={handleChange}
              required
            >
              <option value="DU1">DU1</option>
              <option value="DU2">DU2</option>
              <option value="DU3">DU3</option>
              <option value="DU4">DU4</option>
              <option value="DU5">DU5</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="add-name">Name *</label>
            <input
              type="text"
              id="add-name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Employee full name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="add-email">Email *</label>
            <input
              type="email"
              id="add-email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="employee@example.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="add-department">Department</label>
            <input
              type="text"
              id="add-department"
              name="department"
              value={formData.department}
              onChange={handleChange}
              placeholder="Department name (optional)"
            />
          </div>

          <div style={{ 
            display: 'flex', 
            gap: '10px', 
            justifyContent: 'flex-end',
            marginTop: '20px',
            paddingTop: '20px',
            borderTop: '1px solid #e5e7eb'
          }}>
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={handleClose}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="btn btn-primary" 
              disabled={loading}
            >
              {loading ? 'Creating...' : 'Create Employee'}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
};

export default AddEmployeeDialog;
